module.exports = __webpack_public_path__ + "img/documentacion.6d616aa9.svg";